//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  getEternalEndDate,
  getEternalEndDateV2,
} from '../utils/getEternalEndDate';
import cookie from 'js-cookie';

import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as duration from 'dayjs/plugin/duration';

import CloseButton from './components/closeButton.vue';
import DesignBlock from './components/designBlock.vue';
import DesignBlockInner from './components/designBlockInner.vue';
import DesktopHeading from './components/desktopHeading.vue';
import MobileHeading from './components/mobileHeading.vue';
import Badge from './components/badge.vue';
import DurationBlock from './components/duration.vue';
import Btn from './components/button.vue';

dayjs.extend(utc);
dayjs.extend(duration);

const nameSeparator = '-';
const namePrefix = `sale${nameSeparator}block`;
const externalCookieNamePrefix = 'external';

export default {
  name: 'SharedSaleBlock',
  components: {
    CloseButton,
    DesignBlock,
    DesignBlockInner,
    DesktopHeading,
    MobileHeading,
    Badge,
    DurationBlock,
    Btn,
  },
  props: {
    name: {
      type: String,
    },
    endDate: {
      type: String,
    },
    classes: {
      type: Object,
    },
    isEternal: {
      type: Boolean,
    },
    isEternalV2: {
      type: Boolean,
    },
    isAnchorButton: {
      type: Boolean,
      default: true,
    },
    anchor: {
      type: String,
    },
    buttonLink: {
      type: String,
    },
    isEmbedded: {
      type: Boolean,
      required: true,
    },
    fontUpdateDate: {
      type: Date,
    },
    country: {
      type: String,
    },
  },
  data() {
    return {
      isVisible: false,
      duration: dayjs.duration(0, 'milliseconds', true),
      interval: null,
      saleClass: '',
      saleClasses: [],
      cookieName: '',
      allClassesOnLoadedFonts: [],
    };
  },
  watch: {
    fontUpdateDate() {
      this.setSaleClasses();
    },
  },
  created() {
    this.setCookieName();
    this.setSaleClasses();

    this.duration = dayjs.duration(
      dayjs
        .utc(
          this.isEternalV2
            ? getEternalEndDateV2()
            : this.isEternal
            ? getEternalEndDate()
            : this.endDate,
        )
        .diff(dayjs.utc()),
      'milliseconds',
      true,
    );

    // Если нет нужной куки, то показывается баннер
    if (!cookie.get(this.cookieName)) this.onShow();
  },
  mounted() {
    this.interval = setInterval(() => {
      this.duration = dayjs.duration(
        dayjs
          .utc(
            this.isEternalV2
              ? getEternalEndDateV2()
              : this.isEternal
              ? getEternalEndDate()
              : this.endDate,
          )
          .diff(dayjs.utc()),
        'milliseconds',
        true,
      );
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    getAllClassesOnLoadedFonts() {
      const fonts = this.getAllLoadedFonts();
      return fonts.map((font) => {
        const processedFontName = font.toLowerCase().replace(/[ "]/g, '');

        if (processedFontName === 'futurapt') return `${namePrefix}_futura-pt`;
        else if (processedFontName === 'poppins') {
          return `${namePrefix}_poppins`;
        } else if (processedFontName === 'rubik') return `${namePrefix}_rubik`;
      });
    },
    getAllLoadedFonts() {
      const fonts = document.fonts;
      const fontsArray = [];

      fonts.forEach((fontFace) => {
        fontsArray.push(fontFace.family);
      });

      // converted to set then arr to filter repetitive values
      return [...new Set(fontsArray)];
    },
    onCloseBanner(e) {
      this.isVisible = false;
      cookie.set(this.cookieName, 'true');
      this.$emit('onCloseBanner');
      e.stopPropagation();
      e.preventDefault();
    },
    onShow() {
      this.$emit('onShow');
      this.isVisible = true;
    },
    onClick() {
      this.$emit('onClick');
    },
    getCookieName() {
      const cookieName = `${namePrefix}${nameSeparator}${this.name}`;
      const eternalCookieName = `${namePrefix}${nameSeparator}${externalCookieNamePrefix}${nameSeparator}${this.name}`;

      return this.isEternal ? eternalCookieName : cookieName;
    },
    setCookieName() {
      this.cookieName = this.getCookieName();
    },
    getSaleClass() {
      return `${namePrefix}_${this.name}`;
    },
    setSaleClasses() {
      this.saleClass = this.getSaleClass();
      this.allClassesOnLoadedFonts = this.getAllClassesOnLoadedFonts();
      this.saleAdditionalClasses = [];

      this.saleAdditionalClasses.push(
        `${namePrefix}_${this.isEmbedded ? 'embedded' : 'not-embedded'}`,
      );

      this.saleClasses = [
        this.saleClass,
        this.classes,
        ...this.saleAdditionalClasses,
        ...this.allClassesOnLoadedFonts,
      ];
    },
  },
};
